cobalt-dropdown {
  display: inline-flex;
}

.core-dropdown-items-list .icon-box {
  padding: var(--number-spacing-none);
}

.core-dropdown-items-list .icon-box {
  padding-right: var(--number-spacing-4xsmall);
}

.core-dropdown-items-list .item {
  padding: var(--number-spacing-3xsmall);
}

.core-dropdown-items-list .icon-box {
  padding: var(--number-spacing-none);
}

.core-dropdown-items-list cobalt-dropdown-action-item {
  display: flex;
  width: 100%;
  height: 100%;
}
